// 菜单
export const menus = [
    {
        path: '/',
        title: '首页',
        name: 'index'
    },
    {
        path: 'aboutxh',
        title: '关于协会',
        name: 'aboutxh'
    },
    {
        path: 'news?type=1',
        title: '工作交流',
        name: 'news'
    },
    {
        path: 'tzgg?type=2',
        title: '通知公告',
        name: 'tzgg'
    },
    {
        path: 'hydt?type=5',
        title: '行业动态',
        name: 'hydt'
    },
    {
        path: 'dxal?type=3',
        title: '典型案例',
        name: 'dxal'
    },
    {
        path: 'flfg?type=6',
        title: '法律法规',
        name: 'flfg'
    },
    {
        path: 'jdfw?type=4',
        title: '鉴定服务',
        name: 'jdfw'
    },
    {
        path: 'jdwshy',
        title: '鉴定文书核验',
        name: 'jdwshy'
    }
]
// banner
export const banners = [
    {
        img: require('../assets/images/newspic.png'),
        title: '关于干涉鉴定活动的记录、报告和责任追究制度的办法》',
        content: '提供存证保全、侵权监测、网页取证、司法出证等一站式电子数据保全服务'
    },
    {
        img: require('../assets/images/newspic2.jpg'),
        title: '关于干涉鉴定活动的记录、报告和责任追究制度的办法》',
        content: '提供存证保全、侵权监测、网页取证、司法出证等一站式电子数据保全服务'
    },
    {
        img: require('../assets/images/newspic3.jpg'),
        title: '关于干涉鉴定活动的记录、报告和责任追究制度的办法》',
        content: '提供存证保全、侵权监测、网页取证、司法出证等一站式电子数据保全服务'
    }
]
// 鉴定服务
export const jdfwList = [
    {
        img: require('../assets/images/jdsq_icon.png'),
        title: '鉴定申请',
        path: '/jdapply'

    },
    {
        img: require('../assets/images/fwt_icon.png'),
        title: '鉴定联合服务团',
        path: '/jdlhfwt'

    },
    {
        img: require('../assets/images/jtyth_icon.png'),
        title: '鉴调一体化',
        path: '/jdyth'
    },
    {
        img: require('../assets/images/djzn_icon.png'),
        title: '登记指南',
        path: ''
    },
    {
        img: require('../assets/images/jdrpx_icon.png'),
        title: '鉴定人培训',
        path: '/train'
    },
    {
        img: require('../assets/images/wtzx_icon.png'),
        title: '问题咨询',
        path: '/questions'
    }
]
// 协会服务
export const xhfwList = [
    {
        img: require('../assets/images/xhjs_icon.png'),
        title: '协会简介',
        path: '/aboutxh'
    },
    {
        img: require('../assets/images/glpt_icon.png'),
        title: '鉴定机构信息化管理平台',
        path: 1
    },
    {
        img: require('../assets/images/jdcs_icon.png'),
        title: '鉴定常识',
        path: 2
    },
    {
        img: require('../assets/images/jdws_icon.png'),
        title: '鉴定文书',
        path: 3
    },
    {
        img: require('../assets/images/jsgf_icon.png'),
        title: '技术规范',
        path: 4
    },
    {
        img: require('../assets/images/jdbz_icon.png'),
        title: '鉴定标准',
        path: 5
    }
]
// 底部信息
export const iconBox = [
    {
        img: require('../assets/images/icon_bottom_1.png'),
        title: '质量一流'
    },
    {
        img: require('../assets/images/icon_bottom_2.png'),
        title: '客观公正'
    },
    {
        img: require('../assets/images/icon_bottom_3.png'),
        title: '科学规范'
    },
    {
        img: require('../assets/images/icon_bottom_4.png'),
        title: '诚实守信'
    },
    {
        img: require('../assets/images/icon_bottom_5.png'),
        title: '服务高效'
    }
]
// 协会简介
export const aboutxhContent = '河北省司法鉴定协会是根据《社会团体登记管理条例》设立的，由河北省的司法鉴定机构和司法鉴定人组成的社会团体，受河北省司法局和社团局的指导和监督。它的主要职能和任务是：组织会员学习贯彻党和国家有关司法鉴定的法律、法规和政策；贯彻执行国家司法鉴定标准和技术规范，推进司法鉴定规范化、标准化建设，并对执行情况进行监督和检查；协调沟通有关部门与会员之间的联系，研究、反映司法鉴定工作中的重大问题，为有关部门制定相关的规章制度提供决策依据；制定会员自律准则，形成会员自律管理机制，开展职业道德和执业纪律教育，对违反自律准则、职业道德和执业纪律的会员予以惩戒；接受有关部门委托，对于涉及重大案件或者遇有特别复杂、疑难、特殊的技术问题的鉴定事项，提供鉴定咨询意见；接受有关部门委托，组织开展司法鉴定人教育培训、执业能力评估、职业道德考核等工作，配合行政主管部门处理对会员的投诉，按照有关规定对会员的违规行为进行处分；组织开展学术交流和理论研讨活动，加强与国内外同行之间协作交流，总结工作经验，提高鉴定质量；为会员提供服务，保障会员依法执业，维护会员的合法权益。'
